var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"bg mt-2"},[_c('Step2Timer',{attrs:{"end":true,"daysData":_vm.daysdata},on:{"myFunction":_vm.MyFunction}}),_c('CmpPasscode',{on:{"sendPassCode":_vm.sendReq}}),_c('my-modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModalVisible),expression:"isModalVisible"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }